<!-- Toolbar: matches the Queue tab's minimal, icon-only style -->
<p-toolbar styleClass="rules-toolbar">
  <div class="p-toolbar-group-start align-items-center flex-wrap gap-1">
    <p-button icon="pi pi-refresh" size="small" [text]="true"
              pTooltip="Refresh" tooltipPosition="bottom"
              (onClick)="refresh()">
    </p-button>
    <p-toggleButton [ngModel]="scope === 'all'" (onChange)="setScope($event.checked ? 'all' : 'mine')"
                    onIcon="pi pi-users" offIcon="pi pi-user"
                    [ariaLabel]="scope === 'all' ? 'Showing rules for all users' : 'Showing only your rules'"
                    pTooltip="Switch between mine or all" tooltipPosition="bottom"
                    styleClass="p-button-sm">
    </p-toggleButton>
    <span class="toolbar-separator"></span>
    <p-button icon="pi pi-pencil" size="small" [text]="true"
              [disabled]="!selectedRule"
              pTooltip="Edit" tooltipPosition="bottom"
              (onClick)="editSelected()">
    </p-button>
    <p-button icon="pi pi-play" size="small" [text]="true"
              [disabled]="!selectedRule || selectedRule.enabled"
              pTooltip="Activate" tooltipPosition="bottom"
              (onClick)="activateSelected()">
    </p-button>
    <p-button icon="pi pi-pause" size="small" [text]="true"
              [disabled]="!selectedRule || !selectedRule.enabled"
              pTooltip="Deactivate" tooltipPosition="bottom"
              (onClick)="deactivateSelected()">
    </p-button>
    <p-button icon="pi pi-trash" size="small" [text]="true" severity="danger"
              [disabled]="!selectedRule"
              pTooltip="Delete" tooltipPosition="bottom"
              (onClick)="confirmDeleteSelected()">
    </p-button>
  </div>
</p-toolbar>

<p-table [value]="rules" [loading]="loading" [(selection)]="selectedRule"
         selectionMode="single" dataKey="id"
         styleClass="p-datatable-striped p-datatable-sm"
         [scrollable]="true" scrollHeight="flex">
  <ng-template pTemplate="header">
    <tr>
      <th>Tool</th>
      <th>Monitored Directory</th>
      <th *ngIf="scope === 'all'">Owner</th>
      <th>Active</th>
      <th>Last Run</th>
      <th>Files Triggered</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rule>
    <tr [pSelectableRow]="rule">
      <td>{{toolName(rule)}}</td>
      <td>{{monitoredDirectory(rule)}}</td>
      <td *ngIf="scope === 'all'">{{rule.ownerEmail}}</td>
      <td>
        <i class="pi" [ngClass]="rule.enabled ? 'pi-check-circle' : 'pi-times-circle'"
           role="img" [attr.aria-label]="rule.enabled ? 'Active' : 'Inactive'"></i>
      </td>
      <td>{{rule.lastRunAt ? (rule.lastRunAt | date:'short') : 'Never'}}</td>
      <td>{{rule.totalFilesTriggered}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="scope === 'all' ? 6 : 5" class="text-center text-color-secondary">
        No rules found.
      </td>
    </tr>
  </ng-template>
</p-table>
